import React from 'react';

interface ChartProps {
  data: number[];
  labels: string[];
  color: string;
  height?: number;
}

const SimpleChart: React.FC<ChartProps> = ({ data, labels, color, height = 200 }) => {
  if (data.length === 0) return <div className="h-48 flex items-center justify-center text-neutral-400">No data available</div>;

  const max = Math.max(...data) || 100;
  const min = 0;
  const points = data.map((val, index) => {
    const x = (index / (data.length - 1)) * 100;
    const y = 100 - ((val - min) / (max - min)) * 100;
    return `${x},${y}`;
  }).join(' ');

  const fillPath = `0,100 ${points} 100,100`;

  return (
    <div className="w-full select-none">
      <div className="relative w-full" style={{ height: `${height}px` }}>
        <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="w-full h-full overflow-visible">
          {/* Grid lines */}
          <line x1="0" y1="25" x2="100" y2="25" stroke="#f1f5f9" strokeWidth="0.5" vectorEffect="non-scaling-stroke" />
          <line x1="0" y1="50" x2="100" y2="50" stroke="#f1f5f9" strokeWidth="0.5" vectorEffect="non-scaling-stroke" />
          <line x1="0" y1="75" x2="100" y2="75" stroke="#f1f5f9" strokeWidth="0.5" vectorEffect="non-scaling-stroke" />
          
          {/* Area Fill */}
          <polygon points={fillPath} fill={color} fillOpacity="0.1" />
          
          {/* Line */}
          <polyline
            points={points}
            fill="none"
            stroke={color}
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
          />
          
          {/* Data Points */}
          {data.map((val, index) => {
            const x = (index / (data.length - 1)) * 100;
            const y = 100 - ((val - min) / (max - min)) * 100;
            return (
              <g key={index} className="group cursor-pointer">
                <circle cx={x} cy={y} r="0.5" className="fill-white stroke-2 opacity-0 group-hover:opacity-100 transition-opacity" stroke={color} vectorEffect="non-scaling-stroke" />
                {/* Tooltip on hover */}
                {/* Note: In a real SVG mapping, tooltips are tricky. Simplified here for visual flair. */}
              </g>
            );
          })}
        </svg>
      </div>
      <div className="flex justify-between mt-4 text-xs font-medium text-neutral-400 uppercase tracking-wider">
        {labels.map((label, i) => (
          <span key={i}>{label}</span>
        ))}
      </div>
    </div>
  );
};

export default SimpleChart;